import React from 'react';
import upcomingIcon from '../../../assets/upcomingIcon.svg';

const EventChip = ({ eventName, eventDetail, eventThumbNail }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-3 justify-start pt-2 pb-3 pr-5 pl-2 border-[1px] border-[#38383824] w-full sm:max-w-[550px]">
      {/* Image above the text on mobile, side by side on larger screens */}
      <img src={eventThumbNail} alt="event thumbnail" className=" w-full sm:mb-0 mb-3" />
      <div className="font-inter flex flex-col items-start max-w-full break-words">
        <span className="font-bold text-base text-[#000000] pb-2">{eventName}</span>
        <img src={upcomingIcon} alt="icon" className="pb-3" />
        <span className="font-normal text-[12px] text-justify text-[#000000]">{eventDetail}</span>
      </div>
    </div>
  );
};

export default EventChip;
